import React from "react";
import { useIntl } from "@leagueplatform/locales";
import { usePageViewAnalytics } from "@leagueplatform/analytics";
import { useDocumentTitle } from "@leagueplatform/web-common";
import { Masonry } from "@leagueplatform/masonry";
import { MASONRY } from "common/constants";
import { JourneyContentWrapper } from "components/journey-content-wrapper.component";
import { PageContentWrapper } from "components/page-content-wrapper.component";
import { PageHeader } from "components/page-header/page-header.component";

export const ExplorePage = () => {
  usePageViewAnalytics({ screen_name: "Explore" });
  const { formatMessage } = useIntl();
  const exploreTitle = formatMessage({ id: "STR_EXPLORE" });
  useDocumentTitle(exploreTitle);

  return (
    <PageContentWrapper>
      <PageHeader
        variant="sub-page"
        mobileBand="none"
        headingText={exploreTitle}
      />
      <JourneyContentWrapper>
        <Masonry rootNodeId={MASONRY.ROOT_NODE_ID_EXPLORE} />
      </JourneyContentWrapper>
    </PageContentWrapper>
  );
};
